/**
 * Rozpoznawanie odmowy dostępu zwracanej przez backend.
 *
 * Po audycie z 2026-08-04 procedury ABL sprawdzają, czy kontrahent jest na
 * liście zalogowanego użytkownika (`web_authz.i`). Gdy nie jest, zwracają
 * `flag_ok=no` i komunikat z `authz_denied_msg()`. Bez rozpoznania tego
 * przypadku ekrany zostawały puste — a użytkownik nie wiedział, czy to błąd
 * sieci, brak danych, czy brak uprawnień.
 *
 * Dopasowanie po fragmencie „brak dostepu do danych" jest odporne na polskie
 * znaki: backend pisze komunikaty bez diakrytyków (pliki ABL bywają ASCII),
 * ale gdyby kiedyś doszły, porównanie i tak zadziała po znormalizowaniu.
 */

/** Komunikat pokazywany użytkownikowi — po polsku, z podpowiedzią co zrobić. */
export const ACCESS_DENIED_MESSAGE =
  'Ten kontrahent nie należy do Twojej listy. Jeśli powinien — zgłoś to do biura.';

/** Fragment, który backend zawsze umieszcza w komunikacie odmowy. */
const BACKEND_MARKER = 'brak dostepu do danych';

function normalize(text: string): string {
  return text
    .toLowerCase()
    .replace(/ą/g, 'a').replace(/ć/g, 'c').replace(/ę/g, 'e')
    .replace(/ł/g, 'l').replace(/ń/g, 'n').replace(/ó/g, 'o')
    .replace(/ś/g, 's').replace(/ź/g, 'z').replace(/ż/g, 'z');
}

/**
 * Czy odpowiedź backendu to odmowa dostępu do kontrahenta.
 * Przyjmuje cały obiekt odpowiedzi — komunikat bywa w `row`, `linia`,
 * `lastaction` albo `common`, zależnie od procedury, więc przeszukujemy
 * całość zamiast zgadywać kształt.
 */
export function isAccessDenied(response: unknown): boolean {
  if (!response) return false;
  let serialized: string;
  try {
    serialized = typeof response === 'string' ? response : JSON.stringify(response);
  } catch {
    return false;
  }
  return normalize(serialized).includes(BACKEND_MARKER);
}
